jQuery( $ => {
	setTimeout( function() {
		$( '.custom-cookie-message-banner__text' ).html( function( index, text ) {
			return text.replace( 'or			<', '<' );
		} );

		$( '.custom-cookie-message-banner__text' ).html( function( index, text ) {
			return text.replace( 'eller			<', '<' );
		} );

		$( '.custom-cookie-message-banner__text' ).html( function( index, text ) {
			return text.replace( 'tai			<', '<' );
		} );
	}, 1000 );
} );
